import { globals, US_ADD_TO_CART_BTN } from 'common-ui';
export interface ProductCardPriceTypes {
  productPrice?: number | null;
  productPriceOriginal?: number | null;
  productMemberPrice?: number | null;
  productNumberOfBottles?: number | null;
}
import type { ProductCardProps } from './ProductCard';
import { useTheme } from '@emotion/react';

export const getProductCardStyle = (props: ProductCardProps) => {
  const theme = useTheme();
  const { productCardVariant } = props || {};
  const fullBleedBackground = productCardVariant === 'Full bleed background';
  const standardProductCard = productCardVariant === 'Standard product card';
  if (fullBleedBackground) {
    return theme.widgets.Product?.productCardFullBleed;
  }
  if (standardProductCard) {
    return theme.widgets.Product?.productCardStandard;
  }
  return theme.widgets.Product?.productCardDetailed;
};

export const getProductCardButtonText = (productCardButton: string): string =>
  globals.country === 'us' ? US_ADD_TO_CART_BTN : productCardButton;
